/* TODO: t() */
import React, { ComponentProps, CSSProperties } from 'react';
import { View, StyleSheet } from 'react-native';
import { themeColors } from './Constants';

type InputProps = ComponentProps<'input'>;

type Props = Omit<InputProps, 'style' | 'checked'> & {
  style?: StyleSet;
  checked: boolean;
};

function RadioButton(props: Props) {
  let { style, checked, ...otherProps } = props;
  // TODO: onFocus styling.
  return (
    <View style={[styles.root, style]}>
      <View
        style={[styles.circle, checked && { borderColor: themeColors.blue }]}
      >
        <View style={checked && styles.innerCircle} />
      </View>
      <input
        type="radio"
        checked={checked}
        style={radioStyles}
        {...otherProps}
      />
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle: {
    width: 18,
    height: 18,
    borderRadius: 9,
    borderWidth: 2,
    borderColor: '#657786',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerCircle: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: themeColors.blue,
  },
});

const radioStyles: CSSProperties = {
  display: 'block',
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  margin: 0,
  borderWidth: 0,
  padding: 0,
  width: '100%',
  height: '100%',
  opacity: 0,
  zIndex: 1,
  cursor: 'pointer',
};

export default RadioButton;
